<div mat-dialog-title>
  <h2>{{ 'common.permissions' | t }}</h2>
  <h5>{{ 'users.policyGroups.managePoliciesChoosePermissions' | t }}</h5>
</div>
<div mat-dialog-content>
  <sn-form [form]="form" [model]="model" [fields]="formFields"></sn-form>
</div>
<div mat-dialog-actions>
  <button mat-button (click)="close()" color="danger">{{ 'common.close' | t }}</button>
  <button mat-button (click)="save()" color="success">{{ 'common.save' | t }}</button>
</div>
